import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { styled } from '@mui/material';

export const Container = styled(Flex, {
  shouldForwardProp: (prop) => prop !== 'active',
})<{ active: boolean }>(({ theme, active }) => ({
  color: active ? theme.palette.primary.main : theme.palette.grey.A100,
  [theme.breakpoints.down('sm')]: {
    flex: '1 0 auto',
    margin: theme.spacing(2),
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
  },
  [theme.breakpoints.up('sm')]: {
    padding: theme.spacing(4, 5),
    maxWidth: 220,
    minHeight: 70,
    backgroundColor: theme.palette.grey[100],
    borderRadius: theme.spacing(5),
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    textAlign: 'center',
  },
  [theme.breakpoints.between('sm', 'lg')]: {
    margin: theme.spacing(6),
  },
  [theme.breakpoints.up('lg')]: {
    margin: theme.spacing(8),
  },
}));

export const Subtitle = styled(Text)(({ theme }) => ({
  color: theme.palette.text.primary,
  [theme.breakpoints.down('sm')]: {
    marginLeft: theme.spacing(4),
  },
}));
